import axios from "axios"
import { Service } from "@front-apps/core/services/Service"
import { Partner } from "../models/partners"
import StoreService from "@front-apps/core/services/store"

const serverBaseURL = process.env.REACT_APP_API_BASE_URL

class PartnerApi {
    public static async getPartners(
        group: string,
        pdv: string
    ): Promise<Partner[]> {
        const headers = await Service.getRequestHeaders()
        const token = await StoreService.getInstance().persistant.get("token")
        const authLink = process.env.REACT_APP_CUSTOMER_AUTH_LINK
        let queryParams = `?group=${group}&pdv=${pdv}`
        if (!token && authLink) queryParams += `&link_auth=${authLink}`
        const response = await axios.get(
            `${serverBaseURL}/checkin/partners${queryParams}`,
            {
                headers,
            }
        )
        if (response.status === 200) {
            return response.data
        }
        return []
    }
}

export default PartnerApi
